/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Api_Reference_Related_TitleInputs */

const en_directory_api_reference_related_title = /** @type {(inputs: Directory_Api_Reference_Related_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Related`)
};

const zh_directory_api_reference_related_title = /** @type {(inputs: Directory_Api_Reference_Related_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相关链接`)
};

/**
* | output |
* | --- |
* | "Related" |
*
* @param {Directory_Api_Reference_Related_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_api_reference_related_title = /** @type {((inputs?: Directory_Api_Reference_Related_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Api_Reference_Related_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_api_reference_related_title(inputs)
	return zh_directory_api_reference_related_title(inputs)
});
export { directory_api_reference_related_title as "directory.api_reference.related_title" }